import { Component, Input } from '@angular/core';

@Component({
    selector: 'wdx-audit-row',

    imports: [],
    templateUrl: './wdx-audit-row.component.html',
    styleUrls: ['./wdx-audit-row.component.scss'],
    host: { class: 'd-block' },
})
export class WdxAuditRowComponent {
    @Input() header = false;
    @Input() dataChanged = false;
}
